module.exports = __webpack_public_path__ + "fonts/visuelt-pro-medium.f201250c.woff";